import { getPublicShipment } from './api/tracking'

export default {
  data: () => ({ query: '', shipment: null, error: '', loading: false, showCargoModal: false, requestSequence: 0 }),
  computed: {
    hasShipmentDetails () {
      return this.shipment && ['cargoName', 'supplierName', 'weight', 'volume', 'dimensions', 'packageQuantity'].some(key => this.hasValue(this.shipment[key]))
    }
  },
  mounted () { window.addEventListener('keydown', this.onKeydown) },
  beforeDestroy () { window.removeEventListener('keydown', this.onKeydown) },
  methods: {
    packageCount (value) {
      const match = String(value || '').match(/[\d]+(?:\.\d+)?/)
      return match ? match[0] : value
    },
    hasValue (value) { return value !== null && value !== undefined && String(value).trim() !== '' },
    onKeydown (event) { if (event.key === 'Escape') this.showCargoModal = false },
    normalizeShipment (payload) {
      if (!payload || typeof payload !== 'object' || !this.hasValue(payload.trackingNo)) throw new Error('Invalid tracking response')
      return { ...payload, events: Array.isArray(payload.events) ? payload.events : [] }
    },
    showField (event, field) {
      const hiddenValues = ['待更新', '待确认', 'Pending update', 'Pending confirmation']
      return !(event.nodeCode === 'PRE_CLEARANCE' && field.label === '清关状态') && this.hasValue(field.value) && !hiddenValues.includes(field.value)
    },
    async search () {
      const trackingNo = this.query.replace(/\s+/g, '').toUpperCase()
      if (!trackingNo) { this.error = this.emptyTrackingMessage; return }
      if (trackingNo.length > 100) { this.error = this.longTrackingMessage; return }
      this.query = trackingNo
      this.error = ''
      this.loading = true
      this.showCargoModal = false
      const sequence = ++this.requestSequence
      try {
        const response = await getPublicShipment(encodeURIComponent(trackingNo))
        if (sequence !== this.requestSequence) return
        this.shipment = this.normalizeShipment(response.data)
      } catch (e) {
        if (sequence !== this.requestSequence) return
        this.shipment = null
        this.error = e.response?.status === 404 ? this.notFoundMessage : this.unavailableMessage
      } finally {
        if (sequence === this.requestSequence) this.loading = false
      }
    }
  }
}
